import { ACTION_ERROR, ACTION_ENDED, ACTION_RESET } from "actions/types"

export function catchBlockError(error, dispatch) {
  const { response } = error;
  let errorPayload = "somethingWentWrong";

  if (response) {
    const { status, data } = response;

    // 1. Priorisoidaan backendin lähettämä koodi (Stripe tai muu custom-virhe)
    if (data && data.code) {
      errorPayload = data.code;
    } 
    // 2. Jos koodia ei ole, katsotaan statuskoodeja
    else if (status === 401) {
      errorPayload = "unauthorized";
    } 
    else if (status === 500) {
      errorPayload = "somethingWentWrong";
    }
  }
  // Yhteinen suoritus kaikille tapauksille (myös verkkovirheille)
  dispatch({
    type: ACTION_ERROR,
    payload: errorPayload,
  });

  dispatch({ type: ACTION_ENDED });

  return setTimeout(() => {
    dispatch({ type: ACTION_RESET });
  }, 3000);
}

export const endAndResetAction = (dispatch) => {
  dispatch({ type: ACTION_ENDED })
  dispatch({ type: ACTION_RESET })
}

export const endAndResetActionWithDelay = (dispatch, timeInMs) => {
  dispatch({ type: ACTION_ENDED })
  setTimeout(() => {
    dispatch({ type: ACTION_RESET })
  }, timeInMs)
}

export const delayEndAndResetAction = (dispatch, timeInMs) => {
  setTimeout(() => {
    dispatch({ type: ACTION_ENDED })
    dispatch({ type: ACTION_RESET })
  }, timeInMs)
}

const actionFunctions = {
  catchBlockError,
  endAndResetAction,
  endAndResetActionWithDelay,
  delayEndAndResetAction,
}

export default actionFunctions
